import { render, staticRenderFns } from "./ribbon.vue?vue&type=template&id=cfe4dc9c&scoped=true&"
import script from "./ribbon.component.ts?vue&type=script&lang=ts&"
export * from "./ribbon.component.ts?vue&type=script&lang=ts&"
import style0 from "./ribbon.vue?vue&type=style&index=0&id=cfe4dc9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe4dc9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/profile/profile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfe4dc9c')) {
      api.createRecord('cfe4dc9c', component.options)
    } else {
      api.reload('cfe4dc9c', component.options)
    }
    module.hot.accept("./ribbon.vue?vue&type=template&id=cfe4dc9c&scoped=true&", function () {
      api.rerender('cfe4dc9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/core/ribbon/ribbon.vue"
export default component.exports